import axios from "axios";
import Notiflix from "notiflix";
import seasonConfig from "../data/season.config.json";

// API Endpoint
const API_URL = "https://backend.imagigeeks.org/api/memberShip/create";
// const API_URL = "http://localhost:30058/api/memberShip/create";

// Convertit une date "YYYY-MM-DD" en timestamp Unix (ms), ou undefined si vide
const dateToTimestamp = (dateStr) => {
  if (!dateStr) return undefined;
  const ts = new Date(dateStr).getTime();
  return isNaN(ts) ? undefined : ts;
};

// Function to transform and format data
const formatFormData = (values, isInvited, isBenevole) => {
  return {
    NAME: values.nom,
    FIRST_NAME: values.prenom,
    BIRTH_DATE: dateToTimestamp(values.dateNaissance),
    ADDRESS: values.adressePostale,
    ZIP_CODE: values.zipCode,
    CITY: values.city,
    EMAIL: values.email,
    PHONE: values.telephone,
    ALLERGIES: values.allergies,
    NOTES: values.notes,
    DISABLED_ACCESS: values.pmr,
    DISCORD_ID: values.idDiscord,
    PRACTICE_DOMAIN: values.domainePratique,
    MOTIVATION: values.motivation,
    COSPLAY: values.cosplay,
    GEEK_CULTURE: values.cultureGeek,
    IMAGINARY_CULTURE: values.cultureImaginaire,
    MEMBERSHIP_TYPE: isBenevole ? "BENEVOLE" : isInvited ? "CONVIÉ" : values.statut,
    PAYMENT_METHOD: isInvited ? "GRATUIT" : values.modePaiement,
    RULES_READ: values.reglementInterieurLu,
    IMAGE_RIGHTS_CONSENT: values.imageRightsConsent === true,
    SIGNATURE_DATE: dateToTimestamp(values.dateSignature),
    VEHICLE: values.vehicule === "Non" ? false : true,
    IS_INVITED: isInvited,
    SEASON: seasonConfig.currentSeason,
  };
};

export const submitForm = async (formData, isInvited, isBenevole) => {
  try {
    const formattedData = formatFormData(formData, isInvited, isBenevole);
    const response = await axios.post(API_URL, formattedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    Notiflix.Notify.success("Votre adhésion est maintenant prise en compte. ");
    return response;
  } catch (error) {
    console.error("Error submitting form:", error);
    Notiflix.Notify.failure(
      "Erreur lors de l'envoie du formulaire , contactez un Administrateur ",
    );
    throw error;
  }
};
//TODO Revoir backend pour la gestion des Convié car bug Fortement probable !
